// tslint:disable:max-line-length
import actionCreatorFactory, { Action } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('Player');

export type PlayTrackFromQueueAction = Action<IPlayTrackFromQueueActionPayload>;

export const addTrackToQueue = actionCreator<IAddTrackToQueueActionPayload>('ADD_TRACK_TO_QUEUE');
export const addTracksToQueue = actionCreator<IAddTracksToQueueActionPayload>('ADD_TRACKS_TO_QUEUE');
export const clearQueue = actionCreator('CLEAR_QUEUE');
export const replaceQueue = actionCreator<IAddTracksToQueueActionPayload>('REPLACE_QUEUE');
export const pause = actionCreator('PAUSE');
export const play = actionCreator('PLAY');
export const playNext = actionCreator('NEXT');
export const playPrevious = actionCreator('PREVIOUS');
export const playTrackFromQueue = actionCreator<IPlayTrackFromQueueActionPayload>('PLAY_TRACK');
export const togglePlay = actionCreator('TOGGLE_PLAY');
export const changeTrack = actionCreator<IPlayTrackFromQueueActionPayload>('CHANGE_TRACK');
export const toggleShouldOnlyPlayOriginalTracks = actionCreator<boolean>('TOGGLE_SHOULD_ONLY_PLAY_ORIGINAL_TRACKS');
export const updateCurrentTrackElapsedTime = actionCreator<IUpdateElaspedTimeActionPayload>('UPDATE_CURRENT_TRACK_ELAPSED_TIME');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/player.ts